// extracted by mini-css-extract-plugin
export var aiStarIcon = "_ck-4";
export var closeButton = "_ck-6";
export var dismissButton = "_ck-3";
export var editImageWithAiContainer = "_ck-8";
export var imageUploadWrapper = "_ck-7";
export var misspelledWord = "_ck-5";
export var spellCheckContainer = "_ck-2";
export var spin = "_ck-1";
export var spinning = "_ck-0";